export const HTTP_OK = 200;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_NOT_ACCEPTABLE = 406;
export const HTTP_ENTITY_TOO_LARGE = 413;
export const HTTP_INTERNAL_ERROR = 500;

export const PERMISSION_COMPANIES = 'companies';
export const PERMISSION_USERS = 'user';
export const PERMISSION_ROLES = 'role';

export const PERMISSION_TRUE = 1;
export const PERMISSION_FALSE = 0;

export const ROLE_NO_TYPE = 0;
export const ROLE_TYPE_PLATFORM = 1;
export const ROLE_TYPE_ADMIN = 2;
export const ROLE_TYPE_MANAGER = 3;
export const ROLE_TYPE_CONSULTANT = 4;
export const ROLE_TYPE_CLIENT = 5;
export const ROLE_TYPE_ACCOUNTANCY = 6;
export const ROLE_TYPE_ACCIDENTS = 7;
export const ROLE_TYPE_RSVTI = 8;
export const ROLE_TYPE_SALES = 9;

export const USER_RSVTI_OFF = 0;
export const USER_RSVTI_ON = 1;

export const SEARCH_TIME = 1500;
export const ALERT_TIME = 4000;

export const CHECKED_TRUE = 1;
export const CHECKED_FALSE = 0;

export const vee_config = {
													aria: true,
													classNames: {},
													classes: false,
													delay: 0,
													dictionary: null,
													errorBagName: 'errors', // change if property conflicts
													events: 'input|blur',
													fieldsBagName: 'form_fields',
													i18n: null, // the vue-i18n plugin instance
													i18nRootKey: 'validations', // the nested key under which the validation messages will be located
													inject: true,
													locale: 'en',
													validity: true
												};

export const minitstr_config = {
															//types: TYPES,
															//animation: fadeOut,
															timeout: 3000,
															appendTarget: document.body,
															node: document.createElement('div'),
															style: {
																//Styles
															}
														};





// WEBPACK FOOTER //
// ./src/constants.js